import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'map', 'Map', [["path",{"d":"M3 7l6 -3l6 3l6 -3v13l-6 3l-6 -3l-6 3v-13"}],["path",{"d":"M9 4v13"}],["path",{"d":"M15 7v13"}]]);